import React from 'react'
import LtsLookupCrudDinamico from '../../components/lottus/lts-lookup-crud-dinamico'
import LtsLookupGrupoFinanceiro from '../../components/lottus/lts-lookup-grupo-financeiro'
import LtsLookupPessoa from '../../components/lottus/lts-lookup-pessoa'
import LtsLookupProduto from '../../components/lottus/lts-lookup-produto'
import LtsLookupUnidade from '../../components/lottus/lts-lookup-unidade'

/**
 * lookup.chave (da definição JSON) -> componente de lookup.
 * Mapa explícito (sem import dinâmico) para não quebrar o build do CRA.
 *
 * Tabelas que já possuem lts-lookup-* dedicado entram direto; tabelas expostas
 * apenas via CRUD dinâmico usam o LtsLookupCrudDinamico com a chave da definição.
 */
export const lookupRegistry = {
  grupoFinanceiro: (props) => <LtsLookupGrupoFinanceiro {...props} />,
  pessoa: (props) => <LtsLookupPessoa {...props} />,
  produto: (props) => <LtsLookupProduto {...props} />,
  // adapter: o CRUD dinâmico trabalha com { oid, descricao }; o LtsLookupUnidade com { oid, sigla }
  unidade: ({ value, onChange, ...props }) => (
    <LtsLookupUnidade
      {...props}
      field="sigla"
      value={{ oid: (value && value.oid) || '', sigla: (value && value.descricao) || '' }}
      onChange={(unidade) => onChange(unidade ? { oid: unidade.oid, descricao: unidade.sigla } : null)}
    />
  ),
  // POC: relacionamento resolvido pelo próprio CRUD dinâmico
  crudPocRelacionamento: (props) => <LtsLookupCrudDinamico chave="crud-poc-relacionamento" {...props} />,
}

// "grupoFinanceiro" -> "grupo-financeiro" (chave de definição de CRUD dinâmico)
const toKebab = (chave) => String(chave || '').replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase()

export function resolveLookupComponent(chave) {
  if (!chave) {
    return null
  }
  if (lookupRegistry[chave]) {
    return lookupRegistry[chave]
  }
  // fallback genérico: chave fora do registry resolve pelo CRUD dinâmico da tabela
  // referenciada (precisa existir definição ativa com essa chave em kebab-case)
  return (props) => <LtsLookupCrudDinamico chave={toKebab(chave)} {...props} />
}
